

























import { Component, Prop, Vue } from 'vue-property-decorator';

import { Product, Company } from '@/store/modules/lib';

@Component
export default class ProductDetailsWidget extends Vue {

  @Prop({ type: Object, default: {} }) protected product!: Product;
  @Prop({ type: Array, default: () => [] }) protected standCompanies!: Company[];

}

